export enum BusinessSalaryType {
  MONTHLY = 'MONTHLY',
  HOURLY = 'HOURLY',
}

export const getBusinessSalaryTypeLabel = (object: BusinessSalaryType) => {
  switch (object) {
    case BusinessSalaryType.MONTHLY:
      return $localize`Mensuel`;
    case BusinessSalaryType.HOURLY:
      return $localize`Horaire`;
    default:
      return '';
  }
};
